export const GET_NEW_PRODUCTS = 'newProducts/GET_NEW_PRODUCTS';
export const GET_NEW_PRODUCTS_SUCCESS = 'newProducts/GET_NEW_PRODUCTS_SUCCESS';
export const GET_NEW_PRODUCTS_ERROR = 'newProducts/GET_NEW_PRODUCTS_ERROR';
export const APPLY_PRODUCTS_FILTERS = 'newProducts/APPLY_PRODUCTS_FILTERS';
